import * as uuid from 'uuid'

import { Button, Divider } from '@/shared'
import { type IRuleSection, type ISectionRulesWrapper } from '@App/types/servicesTypes'

import style from './Buttons.module.scss'

interface IProps {
    isFetching: boolean
    showAdd: boolean
    parentId: string
    title: string
    description: string
    sections: IRuleSection[]
    onSetAddMode: () => void
    onChangeRules: (dto: ISectionRulesWrapper, onSuccess?: () => void, withFetching?: boolean) => void
    onSetSectionRules: (sectionRules: ISectionRulesWrapper | null) => void
}

export const Buttons = (props: IProps) => {
    const {
        isFetching,
        showAdd,
        parentId,
        title,
        description,
        sections,
        onSetAddMode,
        onChangeRules,
        onSetSectionRules
    } = props
    const onAddRuleHandler = () => {
        const dto: ISectionRulesWrapper = {
            id: parentId,
            sections: [...sections, { id: uuid.v4(), title, description }]
        }
        const onSuccess = () => {
            onSetSectionRules(null)
        }
        onChangeRules(dto, onSuccess)
    }
    const onRemoveAllRules = () => onChangeRules({ id: parentId, sections: [] })

    return (
        <div className={style.container}>
            <div className={style.divider}>
                <Divider />
            </div>
            <div className={style.wrapper}>
                {!showAdd && (
                    <>
                        <div className={style.btnWrapper}>
                            <Button onClick={onSetAddMode} disabled={isFetching}>
                                Добавить правило
                            </Button>
                        </div>
                        <div className={style.btnWrapper}>
                            <Button onClick={onRemoveAllRules} disabled={isFetching}>
                                Удалить все правила
                            </Button>
                        </div>
                    </>
                )}
                {showAdd && (
                    <div className={style.btnWrapper}>
                        <Button onClick={onAddRuleHandler} disabled={isFetching}>
                            Сохранить
                        </Button>
                    </div>
                )}
            </div>
        </div>
    )
}
